import '@repo/sds/components/_internal/SDSInternalSpinner/SDSInternalSpinner.scss';

const opacities = [1, 0.875, 0.75, 0.625, 0.5, 0.375, 0.25, 0.125];

export function SDSInternalSpinner() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="SDSInternalSpinner"
      role="img"
      aria-label="Loading"
    >
      {[
        'M12.0001 5.76C13.5907 5.76 14.8801 4.47058 14.8801 2.88C14.8801 1.28942 13.5907 0 12.0001 0C10.4095 0 9.12012 1.28942 9.12012 2.88C9.12012 4.47058 10.4095 5.76 12.0001 5.76Z',
        'M8.43139 5.55127C8.43139 7.14185 7.14197 8.43127 5.55139 8.43127C3.96081 8.43127 2.67139 7.14185 2.67139 5.55127C2.67139 3.96068 3.96081 2.67126 5.55139 2.67126C7.14197 2.67126 8.43139 3.96068 8.43139 5.55127Z',
        'M2.88 14.88C4.47058 14.88 5.76 13.5906 5.76 12C5.76 10.4094 4.47058 9.12 2.88 9.12C1.28942 9.12 0 10.4094 0 12C0 13.5906 1.28942 14.88 2.88 14.88Z',
        'M8.43139 18.4487C8.43139 20.0393 7.14197 21.3287 5.55139 21.3287C3.96081 21.3287 2.67139 20.0393 2.67139 18.4487C2.67139 16.8581 3.96081 15.5687 5.55139 15.5687C7.14197 15.5687 8.43139 16.8581 8.43139 18.4487Z',
        'M12.0001 24C13.5907 24 14.8801 22.7106 14.8801 21.12C14.8801 19.5294 13.5907 18.24 12.0001 18.24C10.4095 18.24 9.12012 19.5294 9.12012 21.12C9.12012 22.7106 10.4095 24 12.0001 24Z',
        'M21.3288 18.4487C21.3288 20.0393 20.0394 21.3287 18.4488 21.3287C16.8583 21.3287 15.5688 20.0393 15.5688 18.4487C15.5688 16.8581 16.8583 15.5687 18.4488 15.5687C20.0394 15.5687 21.3288 16.8581 21.3288 18.4487Z',
        'M24.0002 12C24.0002 13.5906 22.7108 14.88 21.1202 14.88C19.5297 14.88 18.2402 13.5906 18.2402 12C18.2402 10.4094 19.5297 9.12 21.1202 9.12C22.7108 9.12 24.0002 10.4094 24.0002 12Z',
        'M21.3288 5.55127C21.3288 7.14185 20.0394 8.43127 18.4488 8.43127C16.8583 8.43127 15.5688 7.14185 15.5688 5.55127C15.5688 3.96068 16.8583 2.67126 18.4488 2.67126C20.0394 2.67126 21.3288 3.96068 21.3288 5.55127Z',
      ].map((d, index) => (
        <path key={d} d={d} fill="currentColor" opacity={opacities[index]} />
      ))}
    </svg>
  );
}
